import StandsGlobalTableHelper from './stands-global-table-helper';

const StandsGlobalHelpers = {
    TableMain: StandsGlobalTableHelper,
}

export default StandsGlobalHelpers;
